export enum EDuplicateManagementUrls {
  BASE = 'duplicate-management',
  DUPLICATES_SEARCH = 'duplicates/search',
  DUPLICATES_DETECT = 'duplicates/detect',
  MERGE = 'merge',
  MERGE_HISTORY_SEARCH = 'merge-history/search',
  PAIRS = 'pairs',
  SWAP = 'swap',
  DISMISS = 'dismiss',
  RESTORE = 'restore',
}
